import React, {useRef} from "react";
import {createPortal} from "react-dom";
import ErrorBoundary from '@components/tailwind/ErrorBoundary';

export default ({ selector, children, replaceContent = true, silent = true }) => {
    const target = useRef(document.querySelector(selector)).current;
    const hasMounted = useRef(false);

    if (!target) return null;

    if (replaceContent && !hasMounted.current) {
        // console.log('MOUNT PORTAL', selector, target.dataset);
        target.innerHTML = '';
        hasMounted.current = true;
    }

    return createPortal(
        <ErrorBoundary {...{silent}}>
            {children(target.dataset)}
        </ErrorBoundary>,
        target
    );
};